import client from './client';
import type { InvestmentSummary, Account } from '../types';

/**
 * 总结与账户 API 封装
 */

/** 获取投资总结 */
export async function fetchSummary(
  period: string = 'all',
  startDate?: string,
  endDate?: string
): Promise<InvestmentSummary> {
  const res = await client.get('/summary', { params: { period, startDate, endDate } });
  return res.data;
}

/** 获取账户信息 */
export async function fetchAccount(): Promise<Account> {
  const res = await client.get('/account');
  return res.data;
}

/** 调整资金 */
export async function adjustBalance(amount: number, remark?: string): Promise<Account> {
  const res = await client.put('/account/balance', { amount, remark });
  return res.data;
}

/** 获取资金流水 */
export async function fetchLedger(limit: number = 50) {
  const res = await client.get('/account/ledger', { params: { limit } });
  return res.data;
}

/** 重置账户 */
export async function resetAccount(): Promise<Account> {
  const res = await client.post('/account/reset');
  return res.data;
}

/**
 * 设定本金 —— 危险操作，会清空全部持仓/成交/流水/每日盈亏
 * 用于换本金档位重新起步（本金与持仓上限需同档位，否则买不满 maxStocks）
 */
export async function setInitialCapital(amount: number): Promise<Account> {
  const res = await client.post('/account/capital', { amount, confirm: true });
  return res.data;
}
